import { render, staticRenderFns } from "./EstadoCuentaPrestamo.vue?vue&type=template&id=d74d1480&scoped=true&"
import script from "./EstadoCuentaPrestamo.vue?vue&type=script&lang=js&"
export * from "./EstadoCuentaPrestamo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74d1480",
  null
  
)

export default component.exports